export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_03.fd772691.jpg";